import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { MiscService } from '../../_service/misc.service';
import { DentalService } from '../../_service/dental.service';
import { SharedService } from '../../_service/shared.service';
import * as XLSX from 'xlsx';
declare var $: any;
@Component({
  selector: 'app-disposition-analysis',
  templateUrl: './disposition-analysis.component.html',
  styleUrls: ['./disposition-analysis.component.css']
})
export class DispositionAnalysisComponent implements OnInit {

  disposition_analysis_loading:boolean=false;analysis_arr = [];total_leads = 0;total_contribution = 0;
  start_date:string='';end_date:string='';circle:string;lead_status:string;circles=[];leadallStatus=[];leadStatus_copy=[];circles_copy=[];
  constructor(private leadapi:LeadsService, private dentalapi:DentalService, private sharedapi:SharedService, public miscapi:MiscService) { }
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;

  ngOnInit(): void {
    this.getcircle();
    this.getleadStatus();
    this.getDispositionAnalysisDataMet();
  }

  async getcircle()
  {
    await this.leadapi.getcircles().subscribe((data:any) => {
        if(data.status)
        {
            this.circles = data.data;
            this.circles_copy = this.circles;
        }else{
            this.circles = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  async getleadStatus()
  {
      await this.leadapi.getLeadStatus().subscribe((data:any) => {
          if(data.status)
          {
              this.leadallStatus = data.data;
              this.leadStatus_copy = this.leadallStatus;
          }else{
              this.leadallStatus = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getDispositionAnalysisDataMet()
  {
    this.disposition_analysis_loading=true;
    this.analysis_arr = [];
    this.total_leads = 0;
    this.total_contribution = 0;
    let qString = 'date_range='+this.start_date+'-'+this.end_date+'&circle='+this.circle+'&lead_status='+this.lead_status;
    await this.dentalapi.getDispositionAnalysisData(qString).subscribe((data:any) => {
        this.disposition_analysis_loading=false;
        if(data.status)
        {
          this.analysis_arr = data.data;
          this.total_leads = this.analysis_arr.map(item => item.total_status_wise_lead).reduce((prev, curr) => prev + curr, 0);
          this.total_contribution = this.analysis_arr.map(item => ((item.total_status_wise_lead/this.total_leads)*100)).reduce((prev, curr) => prev + curr, 0);

        }else{
          this.analysis_arr = [];
          this.total_leads = 0;
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  setSearchValue(type){
    if(type=='lead_status'){
        $("#lead_status_Search").val('');
        $("#lead_status_Search").focus();
        this.leadallStatus= this.leadStatus_copy;
    }else if(type=='circle'){
        $("#circleSearch").val('');
        $("#circleSearch").focus();
        this.circles= this.circles_copy;
    }
  }

searchOnSelect(searchtText: string, type){
    if (type == 'lead_status') {
        this.leadallStatus = this.sharedapi.searchData(searchtText, this.leadStatus_copy, "name");
    }else  if (type == 'circle') {
        this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    }
  }

  dateRangeChangeDispoAnalysis(date1,date2)
  {
    if(date2.value)
    {
      this.start_date = date1.value;
      this.end_date = date2.value;
    }
  }

  clearDate()
  {
    this.dateRangeStart.nativeElement.value = "";
    this.dateRangeEnd.nativeElement.value = "";
    this.start_date = '';
    this.end_date = '';
  }

  resetFilters()
  {
      this.circle = ''; this.lead_status = '';
      this.clearDate();
      this.getDispositionAnalysisDataMet();
  }

  exportDispositionAnalysisReport()
  {
    if(this.analysis_arr.length>0)
    {
      let data = [];
      let titles = [
        'Status/Disposition',
        'Total Lead Count',
        'Contribution %',
      ];
      data.push(titles);
      for(let analysisDataEle in this.analysis_arr)
      {
        let exdata = [
          this.analysis_arr[analysisDataEle].status_name,
          this.analysis_arr[analysisDataEle].total_status_wise_lead,
          ((this.analysis_arr[analysisDataEle].total_status_wise_lead/this.total_leads)*100) ? ((this.analysis_arr[analysisDataEle].total_status_wise_lead/this.total_leads)*100).toFixed(2) : 0,
        ];
        data.push(exdata);
      }
      
      data.push(
        [
          'Total',
          this.total_leads,
          this.total_contribution ? this.total_contribution : 0,
        ]
      );
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
      XLSX.writeFile(wb, 'disposition_analysis_report_'+utc+'.xlsx');
    }
    else
    {
      this.sharedapi.presentToast('No Data Found');
    }
  }

}
